module.exports = __webpack_public_path__ + "static/media/m-penguin-run.1b8a6cff.png";